import classNames from 'classnames'
import React from 'react'

import './styles.scss'

const SettingsTab = ({ options, onSelect, active }) => {
  return (
    <div className="settings-tab">
      <For each="option" of={options}>
        <button
          key={option}
          className={classNames('settings-tab__button', {
            'settings-tab__button--active': active === option,
          })}
          onClick={() => onSelect(option)}
        >
          {option}
        </button>
      </For>
    </div>
  )
}

export default SettingsTab
